import { useHistory } from 'react-router-dom';
import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';
import { useAuthorizationDataContext } from '../../Helpers/AuthorizationDataProvider';
import useFetchWrapper from '../../Helpers/useFetchWrapper';
import { usePopupContext } from "../../Helpers/PopupProvider";
import { useState } from 'react';

const useMyProfileDropdown = () => {
	const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
	const [showHelpPopup, setShowHelpPopup] = useState(false);
	const {
		email,
		deleteData: deleteAuthenticationData,
		getFullName,
		imageId,
	} = useAuthenticationDataContext();
	
	const { role, deleteData: deleteAuthorizationData } =
		useAuthorizationDataContext();

	const { remove } = useFetchWrapper();
	const history = useHistory();

	const { onPopupClose } = usePopupContext();

	const onLogout = async () => {
		const res = await remove('/user/authenticate');
		if (res.status === 200) {
			deleteAuthenticationData();
			deleteAuthorizationData();
			navigate('/');
		}
	};

	const navigate = (link: string, onClose?: () => {}) => {
		history.push(link);
		onClose && onClose();
		onPopupClose();
	};

	const toggleFeedbackPopup = () => {
		showFeedbackPopup && onPopupClose();
		setShowFeedbackPopup((currentValue: boolean) => !currentValue);
	}
	const toggleHelpPopup = () => {
		showHelpPopup && onPopupClose();
		setShowHelpPopup((currentValue: boolean) => !currentValue);
	}

	return {
		navigate,
		onLogout,
		state: {
			email,
			fullName: getFullName(),
			imageId,
			role,
			showFeedbackPopup,
			showHelpPopup
		},
		toggleFeedbackPopup,
		toggleHelpPopup
	};
};
export default useMyProfileDropdown;

